var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M54,.67A53.33,53.33,0,1,0,107.33,54,53.35,53.35,0,0,0,54,.67ZM43.33,78V30l32,24Z","transform":"translate(-0.67 -0.67)"}));
}

Play.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 106.67 106.67"};

module.exports = Play;

Play.default = Play;
